import { FC, FunctionComponent, useEffect, useState } from "react";
import AdminSidebar from "../../components/AdminSideBar/AdminSidebar";
import AdminRightSideAd from "../../components/AdminRightSideAd/AdminRightSideAd";
import "./DashboardLayout.scss";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { ToastContainer } from "react-toastify";
import { useLazyQuery, useMutation } from "@apollo/client";
import { logout, setAdminId, setAdminProfile, setAdminProfileImage, setIsNotificationEnable, setRefetchCurrentUser, setSchoolType, setSelectedClassRoomId } from "../../redux/slices/authSlice";
import ToasterWithMessage from "../../components/toaster";
import { PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from "../../utils/constants";
import TeacherStudentSidebar from '../../components/TeacherStudentSidebar/TeacherStudentSidebar';
import { GET_CURRENT_USER } from "../../pages/AdminDashboard/api/AdminDashboardQuery";
import images from "../../assets/images";
import { visibility } from "../../redux/slices/rightSideAd";
import { GET_CURRENT_PTA_USER } from "../../pages/AdminPta/api/PtaQuery";
import { getAppVersion, getDeviceUUID, getScreenDimensions } from "../../utils/helper";
import { UPDATE_APP_VERSION } from "../../pages/AdminLoginPage/api/AdminLoginQuery";
import MobileSidebar from "../../components/MobileSidebar/MobileSidebar";
import { Padding, Style } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { useRef } from "react";

interface ProType {
  component: FunctionComponent;
}

const DashboardLayout: FC<ProType> = ({ component: Component }) => {
  // get isVisible from the redux and hide the rightSideAd
  const isVisible = useAppSelector((state) => state.rightSideAd.isVisible);
  const { loginpage, role, refetchCurrentUser, hideScrollToTopButton } = useAppSelector((state) => state.auth);
  const [appVersion, setAppVersion] = useState<string | null>(null);
  const [deviceId, setDeviceId] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const {error} = ToasterWithMessage()
  const location = useLocation();
  const baseUrl = process.env.REACT_APP_FRONTEND_URL;
  const { schoolProfileImage, backArrowWhite } = images;
  const containerRef = useRef<HTMLDivElement>(null);

  // get the user details after signIn
  
  const [getCurrentUser, { loading }] = useLazyQuery(GET_CURRENT_USER,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data && data?.getCurrentUser){
        const AdminRole =(data?.getCurrentUser?.nodes[0]?.uRole)?.toLowerCase();
        if(AdminRole === loginpage){
          if(loginpage === 'schooladmin'){
            dispatch(setAdminProfile({profile: data}));
            dispatch(setAdminId(data?.getCurrentUser?.nodes[0]?.schoolAdminsByUId?.nodes[0]?.saId))
            dispatch(setIsNotificationEnable(data?.getCurrentUser?.nodes[0]?.schoolAdminsByUId?.nodes[0]?.saNotificationEnabled))
            dispatch(setAdminProfileImage({ adminProfileImage: data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
          }else if(loginpage === 'teacher'){
            dispatch(setAdminProfile({profile: data}));
            dispatch(visibility({isVisible: false}));
            dispatch(setAdminProfileImage({ adminProfileImage: data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
            dispatch(setSchoolType({schoolType: data?.schoolAdmin?.nodes?.[0]?.adminType}));
          }else if(loginpage === 'student'){
            dispatch(setAdminProfile({profile: data}));
            dispatch(visibility({isVisible: false}));
            dispatch(setAdminProfileImage({ adminProfileImage: data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
            dispatch(setSchoolType({schoolType: data?.schoolAdmin?.nodes?.[0]?.adminType}));
          }
        }else{
          dispatch(logout());
          error("Provide valid credentials")
        }
      }else {
        error("User Not Found!");
      }
    },
    onError: (err) => {
      error(err?.message);
      dispatch(logout());
    }
  });

  const fetchDeviceUUID = async () => {
    try {
      const uuid = await getDeviceUUID();
      setDeviceId(uuid);
    } catch (error) {
      console.error("Failed to fetch app version:", error);
    }
  };

  const fetchAppVersion = async () => {
    try {
      const version = await getAppVersion();
      setAppVersion(version);
    } catch (error) {
      console.error("Failed to fetch app version:", error);
    }
  };

  useEffect(() => {
    fetchAppVersion();
    fetchDeviceUUID();
  }, []);

  const [updateAppVersion] = useMutation(UPDATE_APP_VERSION, {
    fetchPolicy: "no-cache",
    onCompleted: async () => {
      console.log('App version updated successfully');
    },
    onError: (err) => {
      console.log(err,'======App version Update Error');
    }
  });  

  useEffect(() => {
    if(appVersion && deviceId){
      updateAppVersion({
        variables: {
          versionData: {
            deviceToken: deviceId,
            appVersion: appVersion
          }
        }
      })
    }
  },[appVersion, deviceId])

  const [getCurrentPta] = useLazyQuery(GET_CURRENT_PTA_USER,{
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data && data?.getCurrentUser){
        dispatch(setAdminProfile({profile: data}));
        dispatch(visibility({isVisible: false}));
        dispatch(setAdminProfileImage({ adminProfileImage: data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl ? baseUrl + data?.schoolAdmin?.nodes?.[0]?.saAvatarUrl : schoolProfileImage }))
      }
      else {
        error("User Not Found!");
      }
    },
    onError: (err) => {
      error(err?.message);
      dispatch(logout());
    }
  });

  useEffect(() => {
    if(role === PTA_ROLE) {
      getCurrentPta({});
    }
    else {
      getCurrentUser({});
    }
  },[])

  useEffect(() => {
    if (refetchCurrentUser) {
      if(role === PTA_ROLE) {
        getCurrentPta({});
      }
      else {
        getCurrentUser({});
      }
      dispatch(setRefetchCurrentUser({ refetchCurrentUser: false }));
    }
  },[refetchCurrentUser])
  console.log("location", location.pathname);

  const handleScrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  

  const termsAndPrivacyPolicyStyle = (((location?.pathname === "/admin-help/admin-terms-and-privacy-policy") || (location?.pathname === '/teacher-help/teacher-terms-and-privacy-policy') || (location?.pathname === '/student-help/student-terms-and-privacy-policy')) && (getScreenDimensions()?.isMobileScreen))
  return (
    <>
      {(!loading) && (
        <div className={`${isVisible ? "mainContainer" : "HideRightSideAd"}`}>
          {
            (!getScreenDimensions().isMobileScreen && (role === SCHOOL_ADMIN ? <AdminSidebar /> : <TeacherStudentSidebar/>))
          }
          <div
            ref={containerRef}
            className={`${((role === TEACHER_ROLE) || (role === STUDENT_ROLE)) ? (location?.pathname?.includes("/teacher-classroom/chats") || location?.pathname?.includes("/student-classroom/chats")) ? 'teacherMiddleContainerChat' : 'teacherMiddleContainer' : 'middleContainer'} ${(termsAndPrivacyPolicyStyle) ? 'termsAndPolicyMiddleContainer' : ''}`}
          >
            <Component />
            {getScreenDimensions().isMobileScreen && <MobileSidebar />}
          </div>
          {((location?.pathname?.includes("/admin-dashboard") || location?.pathname === "/admin-pta") && hideScrollToTopButton && getScreenDimensions()?.isMobileScreen) && (
            <div className='scrollToTopButton' onClick={handleScrollToTop}>
              <img src={backArrowWhite} className='scrollToTopIcon' alt="scrollToTopIcon" />
            </div>
          )}
          {isVisible && <AdminRightSideAd />}
        </div>
      )}
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};
export default DashboardLayout;
